// extracted by mini-css-extract-plugin
export var container = "weekly-report-question-answers-module--container--H83bK";
export var item = "weekly-report-question-answers-module--item--B6RYP";
export var questionIndex = "weekly-report-question-answers-module--question-index--G2LP4";
export var title = "weekly-report-question-answers-module--title--EqL6G";